import { scrollAnime } from "./components/scrollAnime";
import { humbergerMenuButton } from "./components/humbergerMenuButton";
import { accordion } from "./components/accordion";
import { tab } from "./components/tab";
import { slider } from "./components/slider";
import { inputAddError } from "./components/inputAddError";
import { megaMenu } from "./components/megaMenu";
import { fixButton } from "./components/fixButton";
import { fontSize } from "./components/fontSize";
import { thumbnailSlider } from "./components/thumbnailSlider";
// import { shuttoConfig } from "./components/shuttoConfig";
import { switchingButton } from "./components/switchingButton";

$(document).ready(function () {
  (() => {
    /*
    アニメーション用関数
    */
    //アニメーション用クラスを定義
    const animeEl = ".u-anime";
    //スクロール時に付与されるクラス定義
    const addAnimeClass = "fadeIn";
    scrollAnime(animeEl, addAnimeClass);
  })();

  (() => {
    /*
    ハンバーガーメニュー用関数
    */
    //ハンバーガーメニューボタンクラス定義
    const buttonEl = "#humberge-button";
    //ハンバーガーメニュークラス定義
    const menuEl = "#humberge-menu";
    // テキスト切り替え
    const textEl = ".l-hamburger__button__text";
    // メニュー開閉時に表示切り替え
    const sideEffectEls = [".c-fab"];
    humbergerMenuButton(buttonEl, menuEl, textEl, sideEffectEls);
  })();

  (() => {
    /*
    スライダー用関数
    */
    const sliderEl = ".swiper";
    slider(sliderEl);
  })();

  (() => {
    /*
    アコーディオン用関数
    */
    //アコーディオンラッパークラス定義
    const accordionEl = ".p-switch";
    //アコーディオンボタンクラス定義
    const accordionButtonEl = ".p-switch__button";
    //アコーディオンアイテムクラス定義
    const accordionItemEl = ".p-switch__list";

    const isChildren = false;
    accordion(accordionEl, accordionButtonEl, accordionItemEl, isChildren);

    /*
    スイッチボタン用関数
    */
    //アコーディオンボタンクラス定義
    const switchingButtonEl = ".p-switch__list__container";
    switchingButton(switchingButtonEl);
  })();

  (() => {
    /*
    アコーディオン用関数
    */
    //アコーディオンラッパークラス定義
    const accordionEl = ".l-hamburger__list";
    //アコーディオンボタンクラス定義
    const accordionButtonEl = ".archive";
    //アコーディオンアイテムクラス定義
    const accordionItemEl = ".l-hamburger__archive";

    const isChildren = true;
    accordion(accordionEl, accordionButtonEl, accordionItemEl, isChildren);
  })();

  (() => {
    /*
    タブ用関数
    */
    //タブボタンラッパークラス定義
    const tabButtonEl = ".p-tab__button";
    //タブコンテンツラッパークラス定義
    const tabContentsEl = ".p-tab";
    tab(tabButtonEl, tabContentsEl);
  })();

  (() => {
    /*
    メガメニュー用関数
    */
    //メガメニューラッパークラス定義
    const megaMenuEl = ".l-header__navgation__list";
    //メガメニューナビアイテムクラス定義
    const megaMenuItemEl = ".js-menu";
    //メガメニューコンテンツクラス定義
    const megaMenuContents = ".l-header__navgation__menu";
    megaMenu(megaMenuEl, megaMenuItemEl, megaMenuContents);
  })();

  (() => {
    /*
    フォームバリデーション用関数
    */
    // フォームラッパークラス定義
    const formEl = ".p-form";
    // エラーを付与する要素
    const addErrorEls = [".p-form__wrapper"];
    inputAddError(formEl,addErrorEls);
  })();

  (() => {
    /*
    ページトップボタン用関数
    */
    //ボタンクラス定義
    const fixButtonEl = "#fixButton";
    //
    const hideEl = "#footer";
    //初期状態を定義
    // const hide = false;
    fixButton(fixButtonEl, hideEl);
  })();

  (() => {
    /*
    フォントサイズ変更用関数
    */
    const switchingSizeEl = ".p-switch__list__container";
    fontSize(switchingSizeEl);
  })();

  (() => {
    /*
    サムネイル切り替え用関数
    */
    // メインサムネイルクラス定義
    const mainThubnailEl = ".l-product-single__thumbnail";
    // サブサムネイルラッパークラス定義
    const subThubnailEl = ".l-product-single__thumbnailList";
    thumbnailSlider(mainThubnailEl, subThubnailEl);
  })();

  // (() => {
  //   /*
  //   shutto設定関数
  //   */
    
  //   shuttoConfig();
  // })();
});
